import axios_instance from "../axios.config";

const GetFeeCollectionRecordsDateWise = async (newItem: any) => {
  const { start_date, end_date } = newItem;
  const payload = {
    start_date,
    end_date,
  };
  const response = await axios_instance.post(
    "/student/fee-collection-records-dated",
    payload
  );
  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return [];
  }
};

const GetHeadWiseFeeCollectionReportDateWise = async (newItem: any) => {
  const { start_date, end_date, academic_year } = newItem;
  const payload = {
    start_date,
    end_date,
    academic_year,
  };

  const response = await axios_instance.post(
    "/student/headwise-collection-report",
    payload,
    {
      responseType: "blob",
    }
  );

  console.log(response);

  const contentType = response.headers["content-type"];

  if (contentType && contentType.includes("application/json")) {
    // If backend sent a JSON response inside a blob (e.g. NO_RECORDS)
    const text = await response.data.text(); // Convert blob to text
    const json = JSON.parse(text);
    return json; // { status: 'NO_RECORDS', message: '...' }
  } else {
    // Otherwise assume it's CSV blob
    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "head_wise_fee_report.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
};

const GetStudentMasterData = async () => {
  const response = await axios_instance.get("/student/get-all-student");

  const contentType = response.headers["content-type"];

  if (contentType && contentType.includes("application/json")) {
    // If backend sent a JSON response inside a blob (e.g. NO_RECORDS)
    const text = await response.data.text(); // Convert blob to text
    const json = JSON.parse(text);
    return json; // { status: 'NO_RECORDS', message: '...' }
  } else {
    // Otherwise assume it's CSV blob
    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "active_students.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
};

const GetCategoryWiseData = async (newItem: any) => {
  const { class_id, section_id } = newItem;
  const payload = {
    class_id,
    section_id,
  };

  const response = await axios_instance.post(
    "/student/get-student-category-report",
    payload,
    {
      responseType: "blob",
    }
  );

  const contentType = response.headers["content-type"];

  if (contentType && contentType.includes("application/json")) {
    // If backend sent a JSON response inside a blob (e.g. NO_RECORDS)
    const text = await response.data.text(); // Convert blob to text
    const json = JSON.parse(text);
    return json; // { status: 'NO_RECORDS', message: '...' }
  } else {
    // Otherwise assume it's CSV blob
    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "student_category_report.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
};

const GetTransportData = async (newItem: any) => {
  const { class_id, section_id } = newItem;
  const payload = {
    class_id,
    section_id,
  };

  const response = await axios_instance.post(
    "/student/get-transport-report",
    payload,
    {
      responseType: "blob",
    }
  );

  const contentType = response.headers["content-type"];

  if (contentType && contentType.includes("application/json")) {
    // If backend sent a JSON response inside a blob (e.g. NO_RECORDS)
    const text = await response.data.text(); // Convert blob to text
    const json = JSON.parse(text);
    return json; // { status: 'NO_RECORDS', message: '...' }
  } else {
    // Otherwise assume it's CSV blob
    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "transport_report.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
};

const GetFeeDuesReport = async (newItem: any) => {
  const { class_id, section_id, inputMonthStr, academic_year } = newItem;
  const payload = {
    class_id,
    section_id,
    inputMonthStr,
    academic_year,
  };

  const response = await axios_instance.post(
    "/student/fee-due-report",
    payload
  );

  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return [];
  }
};

const GetStopWiseData = async (newItem: any) => {
  const { class_id, section_id } = newItem;
  const payload = {
    class_id,
    section_id,
  };

  const response = await axios_instance.post(
    "/student/get-stop-wise-report",
    payload,
    {
      responseType: "blob",
    }
  );

  const contentType = response.headers["content-type"];

  if (contentType && contentType.includes("application/json")) {
    // If backend sent a JSON response inside a blob (e.g. NO_RECORDS)
    const text = await response.data.text(); // Convert blob to text
    const json = JSON.parse(text);
    return json; // { status: 'NO_RECORDS', message: '...' }
  } else {
    // Otherwise assume it's CSV blob
    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Stop_wise_report.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
};

export {
  GetFeeCollectionRecordsDateWise,
  GetFeeDuesReport,
  GetHeadWiseFeeCollectionReportDateWise,
  GetStudentMasterData,
  GetCategoryWiseData,
  GetTransportData,
  GetStopWiseData,
};
